import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VehicleTypeService } from '@general/proxy/general/controllers/vehicle-type.service';

FieldBuilder.setNamespace('Controlling');

export const CONDITIONALFORCALCULATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('validSinceDate', 'Entity.ConditionalForCalculation.ValidSinceDate')
    .required()
    .build(),
  FieldBuilder
    .number('grossLessThan', 'Entity.ConditionalForCalculation.GrossLessThan')
    .build(),
  FieldBuilder
    .number('tareLessThan', 'Entity.ConditionalForCalculation.TareLessThan')
    .build(),
  FieldBuilder
    .number('tareGreaterThan', 'Entity.ConditionalForCalculation.TareGreaterThan')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vehicleTypeId', 'Entity.VehicleType', VehicleTypeService)
    .required()
    .display('name') 
    .keyField('id') 
    .build(),,
];

export const CONDITIONALFORCALCULATION_CONFIG = {
  entityName: 'ConditionalForCalculation',
  localizationKey: 'Controlling::Entity.ConditionalForCalculation',
  fields: CONDITIONALFORCALCULATION_FIELDS,
  permission: 'ControllingLiquidations.ConditionalForCalculations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
